<template>
<div class="center-content">
  <div class="row">
    <a
      href="https://www.buymeacoffee.com/bgriffin"
      class="bmc-button"
    >
      <img src="https://www.buymeacoffee.com/assets/img/BMC-btn-logo.svg" alt="Buy me a coffee">
      <span style="margin-left:5px">Buy me a coffee</span>
    </a>
  </div>
  <div style="margin: 0 auto; margin-top: 10px;">
    BTC: 3Gr6pqHNyu8sUtDUr9hv6c6fggd9Hs3GzJ
  </div>
  <div style="margin: 0 auto;">
    ETH: 0xd1E2b646AcFEc57DD837F4D8D54FeEd332f75153
  </div>
  <div style="margin: 0 auto;">
    SHIB: 0x6EDF9C4cE0fE17847CeDfdf574068e3a813aa48A
  </div>
  <div style="margin: 0 auto;">
    ONE: one13rdpsjy8pu203ejw0v00mvrpv0e8eqqnhg2z3m
  </div>
</div>
</template>
  

<style lang="scss" scoped>
@import '../styles/variables.scss';

.bmc-button img {
  width: 27px !important;
  margin-bottom: 1px !important;
  box-shadow: none !important;
  order: none !important;
  vertical-align: middle !important;
}

.bmc-button {
  line-height: 36px !important;
  height:37px !important;
  text-decoration: none !important;
  display:inline-flex !important;
  color:#ffffff !important;
  background-color:#40DCA5 !important;
  border-radius: 3px !important;
  border: 1px solid transparent !important;
  padding: 1px 9px !important;
  font-size: 23px !important;
  letter-spacing:0.6px !important;
  box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5) !important;
  -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  margin: 0 auto !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  -o-transition: 0.3s all linear !important;
  -webkit-transition: 0.3s all linear !important;
  -moz-transition: 0.3s all linear !important;
  -ms-transition: 0.3s all linear !important;
  transition: 0.3s all linear !important;
}

.bmc-button:hover, .bmc-button:active, .bmc-button:focus {
  -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  text-decoration: none !important;
  box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
  opacity: 0.85 !important;
  color: $color-primary-text !important;
}
</style>